var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_c('div',{staticClass:"text__text",domProps:{"innerHTML":_vm._s(_vm.content.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }